<template>
  <div class="communicate-wrap">
    <img :src="require('../../assets/img/communication/error.png')" />
    <div class="communicate-text">会议记录已被确认</div>
  </div>
</template>

<script>
export default {
  name: 'Form',

  mixins: [],

  components: {},

  props: {},

  data() {
    return {};
  },

  computed: {},

  watch: {},

  created() {},

  mounted() {},

  destroyed() {},

  methods: {},
};
</script>

<style lang="less" scoped>
.communicate-wrap {
  text-align: center;
  padding: 96px 15px 0;
}

.communicate-text {
  font-size: 16px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #343434;
  line-height: 25px;
  margin: 12px 0 40px;
}
</style>
